import React from 'react';
import LegacyRadioButton, { RadioButtonProps } from './RadioButton.legacy';
import AlphaRadioButton from './RadioButton.alpha';

const Component = process.env.IS_LEGACY ? LegacyRadioButton : AlphaRadioButton;
export default Component as React.FC<RadioButtonProps>;
export type { RadioButtonProps };
